import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';

@Component({
  selector: 'threat-objectives-details',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './threat-objectives-details.component.html',
  styleUrl: './threat-objectives-details.component.css'
})
export class ThreatObjectivesDetailsComponent {
  icons = Icons;

  @Input() threatGoals: any | null = null;

  @Output() onClose = new EventEmitter<void>;

  closeModal(): void {
    this.onClose.emit();
  }
}
